// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3B-kpsVBvMQQgGLX7FfoYC","actionList":"_2R2DRx0UmqwmY5sffoFHPu","actionItem":"_1LYFJBuOq3dy332OHC6OoC"};